@switch (nachrichtState) {

    @case (NachrichtStateEnum.PREPARE) {

        @if (nachrichtenVerfahren === Verfahren.STEP) {
            <kokos-nachricht-prepare-step
                    scrollIntoView
                    [anliegenMap]="anliegenMap"
                    [dienststellenMap]="dienststellenMap"
                    (nachrichtPayload)="setNachricht($event)"
                    (anliegenName)="setAnliegenName($event)"
                    (subanliegenChanged)="setSubanliegen($event)">
            </kokos-nachricht-prepare-step>

        } @else if (nachrichtenVerfahren === Verfahren.KIWI) {
            <kokos-nachricht-prepare-kiwi
                    scrollIntoView
                    [anliegenList]="anliegenMap[NachrichtenTypeEnum.FAMKA]"
                    [dienststelle]="dienststellenMap[NachrichtenTypeEnum.FAMKA]"
                    (nachrichtPayload)="setNachricht($event)"
                    (anliegenName)="setAnliegenName($event)">
            </kokos-nachricht-prepare-kiwi>
        } @else if (nachrichtenVerfahren === Verfahren.ZAV) {
            <kokos-nachricht-prepare-zav
                    [anliegenList]="anliegenMap[NachrichtenTypeEnum.ZAV]"
                    [dienststelle]="dienststellenMap[NachrichtenTypeEnum.ZAV]"
                    (nachrichtPayload)="setNachricht($event)"
                    (anliegenName)="setAnliegenName($event)"
                    (subanliegenChanged)="setSubanliegen($event)">
            </kokos-nachricht-prepare-zav>
        }
    }
    @case (NachrichtStateEnum.FORM) {
        <kokos-nachricht-form
                scrollIntoView
                [nachrichtPayload]="nachrichtPayload"
                [anliegenName]="anliegenName"
                [subanliegenName]="subanliegenName"
                [showUpload]="anhangErlaubt"
        ></kokos-nachricht-form>
    }
}